<!-- address.calendar.day.html !-->
<div class="addressday  esunlink" [ngStyle]="getDayStyleBackGround()" (click)="dayclick()">
    <div class="detail" [ngStyle]="getDayStyleFont()">
        {{showSkin}}
    </div>
</div>